import React, { useState, useEffect } from "react";
import Router from "next/router";
import moment from "moment";
import Link from "next/link";
import detailRed from "../../../public/static/images/svg/details_active.svg";
import tncRed from "../../../public/static/images/svg/tnc_active.svg";
import BreadcrumbComponent from "../UserInterface/BreadcrumbComponent";
import { SocialMediaShareBar } from "../../components/SocialMedia/SocialMediaShareBar";
import { dynamicUrl } from "../../utils/dynamic-url";
import { checkIsFromDashboard, inIframe } from "../../utils/helpers";
import UseWindowSize from "../UseWindowSize";
import { PromoLeads } from "./PromoLeads";

moment.locale("id");

type ActivePageProps = {
  title: string;
  startdate: string;
  enddate: string;
  description: string;
  urlCTA: string;
  urlCTAMobile: string;
  textBtnCTA: string;
  textBtnCTAMobile: string;
};

const ActivePage = ({
  title,
  startdate,
  enddate,
  description,
  urlCTA,
  urlCTAMobile,
  textBtnCTA,
  textBtnCTAMobile
}: ActivePageProps) => {
  const { width } = UseWindowSize();
  const [winSize, setWinSize] = useState(null);

  useEffect(() => {
    setWinSize(width);
  });

  return (
    <div className="active-page-wrapper">
      <div className="active-page-title">{title}</div>
      <div className="active-page-subtitle">
        Periode {moment(startdate).format("LL")} -{" "}
        {moment(enddate).format("LL")}
      </div>
      <SocialMediaShareBar
        title={title}
        WidthAuto={false}
      ></SocialMediaShareBar>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <PromoLeads valueDump={{ commodity: title }}></PromoLeads>
      </div>
      <div
        className="active-page-description"
        dangerouslySetInnerHTML={{ __html: description }}
      />
      {winSize > 600 ? ( // is desktop
        urlCTA &&
        textBtnCTA && ( // has urlDesktop and textButtonDesktop
          <Link href={dynamicUrl(urlCTA)} as={urlCTA}>
            <a className="active-page-apply-button">{textBtnCTA}</a>
          </Link>
        )
      ) : //is mobile
      urlCTAMobile &&
        urlCTAMobile !== "" &&
        textBtnCTAMobile &&
        textBtnCTAMobile !== "" ? ( // has urlMobile and textButtonMobile
        <Link href={dynamicUrl(urlCTAMobile)} as={urlCTAMobile}>
          <a className="active-page-apply-button">{textBtnCTAMobile}</a>
        </Link>
      ) : (
        urlCTA &&
        urlCTA !== "" &&
        textBtnCTA &&
        textBtnCTA !== "" && ( // has urlDesktopForMobileView and textButtonDesktopForMobileView
          <Link href={dynamicUrl(urlCTA)} as={urlCTA}>
            <a className="active-page-apply-button">{textBtnCTA}</a>
          </Link>
        )
      )}
      <style jsx global>{`
        .error-msg {
          color: var(--color-red);
          margin: 0px 0 5px 0;
        }
        .active-page-description table {
          border-collapse: collapse;
        }
        .active-page-description table,
        th,
        td {
          border: 1px solid black;
          padding: 8px;
        }
        .active-page-wrapper {
          display: flex;
          flex-direction: column;
          margin-bottom: 0px;
        }
        .active-page-title {
          font-size: 24px;
          font-weight: bold;
          text-align: center;
          margin: 48px 16px 8px 16px;
        }
        .active-page-subtitle {
          font-size: 18px;
          text-align: center;
          margin: 12px;
        }
        .active-page-description {
          font-size: 16px;
          margin: 32px 16px 0 16px;
        }
        .active-page-description p {
          font-size: 16px;
        }
        .active-page-description ul {
          font-size: 16px;
          margin-left: 40px;
          list-style-type: disc;
        }
        .active-page-description a {
          color: var(--color-red);
        }
        .active-page-description li {
          margin-left: 40px;
        }
        .active-page-description ul li {
          font-size: 16px;
        }
        .active-page-description ol {
          font-size: 16px;
          margin-left: 40px;
        }
        .active-page-description ol li {
          font-size: 16px;
          list-style-type: decimal;
        }
        .active-page-apply-button {
          align-self: center;
          font-size: 15px;
          font-weight: bold;
          width: auto;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: var(--color-red);
          color: var(--color-white);
          border-radius: 10px;
          margin: 48px 0 64px 0;
          padding: 8px 40px;
        }
        .active-page-apply-button:hover {
          cursor: pointer;
        }

        @media only screen and (max-width: 850px) {
          .active-page-description figure img {
            width: 90vw;
          }
        }

        @media only screen and (max-width: 600px) {
          .active-page-title {
            font-size: 18px;
          }
          .active-page-subtitle {
            font-size: 16px;
          }
          .active-page-description ol {
            margin-left: 20px;
          }
          .active-page-description ul {
            margin-left: 20px;
            list-style-type: disc;
          }
          .active-page-description li {
            margin-left: 20px;
          }
        }
      `}</style>
    </div>
  );
};

type DetailPromoProps = {
  title?: string;
  subtitle?: string;
  description?: string;
  startdate?: string;
  enddate?: string;
  hideTab?: boolean;
  breadcrumb?: any;
  promo_url_cta?: string;
  promo_url_cta_mobile?: string;
  promo_text_button_cta?: string;
  promo_text_button_cta_mobile?: string;
};

const DetailPromo = ({
  title,
  description,
  startdate,
  enddate,
  hideTab,
  breadcrumb,
  promo_url_cta,
  promo_text_button_cta,
  promo_url_cta_mobile,
  promo_text_button_cta_mobile
}: DetailPromoProps) => {
  const [pageActive, setPageActive] = useState(
    <ActivePage
      title={title}
      description={description}
      startdate={startdate}
      enddate={enddate}
      urlCTA={promo_url_cta}
      urlCTAMobile={promo_url_cta_mobile}
      textBtnCTA={promo_text_button_cta}
      textBtnCTAMobile={promo_text_button_cta_mobile}
    />
  );
  const [tabToTop, setTabToTop] = useState(Boolean);

  useEffect(() => {
    setTabToTop(checkIsFromDashboard(Router));

    if (inIframe()) {
      setTabToTop(true);
    }
  });

  return (
    <div className="detail-promo-wrapper">
      <div className="detail-promo-container">
        {!hideTab && (
          <div className="detail-promo-body-button">
            <div
              className="detail-button-active"
              onClick={() => {
                // toggleClass;
                setPageActive(
                  <ActivePage
                    title={title}
                    startdate={startdate}
                    enddate={enddate}
                    description={description}
                    urlCTA={promo_url_cta}
                    urlCTAMobile={promo_url_cta_mobile}
                    textBtnCTA={promo_text_button_cta}
                    textBtnCTAMobile={promo_text_button_cta_mobile}
                  />
                );
              }}
            >
              <img src={detailRed} />
              Detil Promo
            </div>

            <Link href="/temukan-lokasi-kami" as="/temukan-lokasi-kami">
              <a target="_blank" className="detail-button-inactive">
                <img src={tncRed} />
                Temukan Lokasi Kami
              </a>
            </Link>
          </div>
        )}
        <BreadcrumbComponent items={breadcrumb} />
        <div>{pageActive}</div>
      </div>
      <style jsx>{`
        .detail-promo-wrapper {
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        .detail-promo-container {
          max-width: 940px;
          width: 100%;
          display: flex;
          flex-direction: column;
        }
        .detail-promo-banner {
          height: auto;
        }
        .detail-promo-banner img {
          width: 100%;
          height: 100%;
          min-height: 120px;
        }
        .detail-promo-body-button {
          display: flex;
          justify-content: space-around;
          position: -webkit-sticky;
          top: ${!tabToTop ? "64px" : "0px"};
          position: sticky;
          z-index: 2;
        }
        .detail-promo-body-button div:hover {
          cursor: pointer;
        }
        .detail-promo-body-button .detail-button-active {
          background-color: var(--color-white);
          border-bottom: solid 6px var(--color-red);
          color: var(--color-red);
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          height: 74px;
          font-size: 18px;
        }
        .detail-promo-body-button .detail-button-active img {
          margin-right: 24px;
        }
        .detail-promo-body-button .detail-button-inactive {
          background-color: var(--color-white-soft);
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          height: 80px;
          font-size: 18px;
        }
        .detail-promo-body-button .detail-button-inactive img {
          margin-right: 24px;
          -webkit-filter: grayscale(100%);
          /* Safari 6.0 - 9.0 */
          filter: grayscale(100%);
        }
        @media only screen and (max-width: 600px) {
          .detail-promo-body-button .detail-button-inactive {
            height: 42px;
            font-size: 12px;
          }
          .detail-promo-body-button .detail-button-inactive img {
            display: none;
          }
          .detail-promo-body-button .detail-button-active {
            height: 36px;
            font-size: 12px;
          }
          .detail-promo-body-button .detail-button-active img {
            display: none;
          }
        }
      `}</style>
    </div>
  );
};

export default DetailPromo;
